module.exports = __webpack_public_path__ + "img/goods11.54017dcd.jpg";